/**
 * Calendar Month View Functionality
 *
 * TODO: convert this to vue, it was built before BB got here
 */
import Modernizr from '@/.modernizrrc'
import whatInput from 'what-input'

function calendarInit() {
  if (document.getElementById('calendar_month_view') !== null) {
    const calendar: any = {
      el: document.getElementById('calendar_month_view'),
      init() {
        this.small = window.matchMedia('only screen and (max-width: 600px)')
        this.days = this.el.querySelectorAll('.has-popup')
        this.dropdown = document.getElementById('calendarActions')

        this.clickEvent = Modernizr.touchevents ? 'touchstart' : 'click'

        this.days.forEach((day) => {
          day.addEventListener('mouseenter', () => this.rollover(day))
          day.addEventListener('mouseleave', () => this.rollout(day))
          day.addEventListener(this.clickEvent, (event) => {
            if (event.target.className !== 'calendar-view-day') {
              this.click(day, event.type)
            }
          })
          const allDays = day.querySelectorAll('.close-calendar-popup')[0]
          allDays.addEventListener(
            this.clickEvent,
            (event) => {
              day.classList.remove('show-hover')
              event.stopPropagation()
            },
            false,
          )
        })
        this.dropdown.addEventListener('change', function () {
          if (this.value) {
            window.location.href = this.value
            this.selectedIndex = 0
          }
        })
      },
      rollover(day) {
        if (whatInput.ask('intent') === 'mouse' && !this.small.matches) {
          day.classList.add('show-hover')
        }
      },
      rollout(day) {
        if (whatInput.ask('intent') === 'mouse' && !this.small.matches) {
          day.classList.remove('show-hover')
        }
      },
      click(day, eventType) {
        const clickTest = eventType === 'click' ? this.small.matches : true
        if (clickTest) {
          this.days.forEach((_day) => {
            if (_day.classList.contains('show-hover') && day !== _day) {
              _day.classList.remove('show-hover') // Ensure all days close
            }
          })
          day.classList.toggle('show-hover')
        }
      },
    }
    calendar.init()
  }
}

export default calendarInit
